import Popover from '@mui/material/Popover';
import { useState } from 'react';

import type { Hcphco } from '@/core/graphql/generated/types';

import { useInlineEditContext } from '../InlineEditContext';

import { NameEditForm } from './NameEditForm';
import { nameEditPopoverStyles } from './NameEditPopover.styles';

type Props = {
	profile: Hcphco;
	anchorEl: Element | null;
	open: boolean;
	onClose: () => void;
};

export const NameEditPopover = ({
	profile,
	anchorEl,
	open,
	onClose
}: Props) => {
	const ctx = useInlineEditContext();

	const [closing, setClosing] = useState(false);
	const [prevOpen, setPrevOpen] = useState(open);
	if (prevOpen !== open) {
		if (prevOpen && !open) setClosing(true);
		setPrevOpen(open);
	}

	const handleClose = () => {
		ctx?.requestCloseActive();
	};

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			disableScrollLock
			marginThreshold={16}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			transformOrigin={{ vertical: 'top', horizontal: 'center' }}
			slotProps={{
				root: { sx: nameEditPopoverStyles.root },
				paper: {
					elevation: 8,
					sx: nameEditPopoverStyles.paper
				},
				transition: { onExited: () => setClosing(false) }
			}}
		>
			{(open || closing) && (
				<NameEditForm profile={profile} onClose={onClose} />
			)}
		</Popover>
	);
};
